import { Avatar, type AvatarProps } from '@mui/material';
import type React from 'react';
import { useEffect, useState } from 'react';
import type { StorageDownloadURLResult } from '../../services/storageService';
import storageService from '../../services/storageService';

interface StorageAvatarProps extends Omit<AvatarProps, 'src'> {
  src?: string | null | undefined;
}

export const StorageAvatar: React.FC<StorageAvatarProps> = ({ src, ...props }) => {
  const [resolvedUrl, setResolvedUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!src) {
      setResolvedUrl(undefined);
      return;
    }

    if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('data:')) {
      setResolvedUrl(src);
      return;
    }

    // It's a storage path, fetch the download URL
    let isMounted = true;
    storageService
      .getDownloadURL(src)
      .then((result: StorageDownloadURLResult) => {
        if (isMounted && result.success && result.url) {
          setResolvedUrl(result.url);
        }
      })
      .catch((_error: unknown) => {
        // Failed to resolve storage URL
      });

    return () => {
      isMounted = false;
    };
  }, [src]);

  return <Avatar src={resolvedUrl} {...props} />;
};
